import React from 'react'
import { ReactSVG } from 'react-svg'
import {
  LoginBackground,
  LoginCard,
  LoginContainer,
  LoginLogo,
} from './Login.styles'
import wayboxLogo from '../../assets/waybox-logo.svg'
import { CompleteSignUpForm } from './CompleteSignUpForm'

export const Register = () => {
  return (
    <LoginBackground>
      <LoginContainer>
        <LoginCard elevation={2}>
          <LoginLogo>
            <ReactSVG src={wayboxLogo} alt="waybox logo" />
          </LoginLogo>
          <CompleteSignUpForm />
        </LoginCard>
      </LoginContainer>
    </LoginBackground>
  )
}
